import React,{Component} from 'react';
import picVinay from '../../images/leadership/pic-vinay@2x.png';
import cgo from '../../images/leadership/cgo.jpeg';
import {Link} from 'react-router-dom'
import AliceCarousel from 'react-alice-carousel';
import {Popup,PopupButton,PopupBody} from '../../components/common/Popup'
import ActiveWrapper from '../../components/common/ActiveWrapper'
import "react-alice-carousel/lib/alice-carousel.css";

const responsive = {
    1460: {
        items: 1
    }
};

class LeaderCarousel extends Component{
    render(){
        return <div className={'leader-container'}>
            <div className={'close'} onClick={()=>this.props.closePreview()}></div>
            <AliceCarousel autoPlay={false} autoPlayInterval={5000} duration={500} responsive={responsive} dotsDisabled={true} buttonsDisabled={true} ref={(el) => (this.Carousel = el)} startIndex={this.props.index}>
                <div className={'leader'}>
                    <img className={'img web'} src={picVinay}/>
                    <div className={'info web'}>
                        <div className={'name'}>Vinay Agrrawal</div>
                        <div className={'sub'}>Founder | Mentor | Innovator | Fitness Enthusiast | Investor</div>
                        <p>Though his dream is to build new companies every minute, Vinay busies himself by running day-to-day operations at Hubler. His favorite thing about being an entrepreneur is solving complex ideas and distilling them into new businesses. In fact, he’s transformed companies to unlock immediate gains by at least 75% YoY growth without sacrificing on his fitness routine. Driven by his love for innovating, he led the creation, and subsequent acquisition, of his company Unicel Technologies – a leading enterprise cloud communication solutions provider.
                            Not only is he a pro at creating high performance organizations, he also advises businesses
                            on product roadmap and delivering world class solutions.</p>
                        <p>- -</p>
                        <p>Vinay attended Symbiosis (Pune) before moving to the telecom sector. From banking OTPs to your product orders; finding unique ways to deliver messages that matter to people and businesses.</p>
                    </div>
                    <div className={'mobile-view'}>
                        <div className={'header-cls'}>
                            <img className={'img'} src={picVinay}/>
                            <div className={'desig'}>
                                <div className={'name'}>Vinay Agrrawal</div>
                                <div className={'sub'}>Founder | Mentor | Innovator | Fitness Enthusiast | Investor</div>
                            </div>
                        </div>
                        <p>Though his dream is to build new companies every minute, Vinay busies himself by running day-to-day operations at Hubler. His favorite thing about being an entrepreneur is solving complex ideas and distilling them into new businesses. In fact, he’s transformed companies to unlock immediate gains by at least 75% YoY growth without sacrificing on his fitness routine. Driven by his love for innovating, he led the creation, and subsequent acquisition, of his company Unicel Technologies – a leading enterprise cloud communication solutions provider.
                            Not only is he a pro at creating high performance organizations, he also advises businesses
                            on product roadmap and delivering world class solutions.</p>
                        <p>- -</p>
                        <p>Vinay attended Symbiosis (Pune) before moving to the telecom sector. From banking OTPs to your product orders; finding unique ways to deliver messages that matter to people and businesses.</p>
                    </div>
                </div>
                <div className={'leader'}>
                    <img className={'img web'} src={cgo}/>
                    <div className={'info web'}>
                        <div className={'name'}>Rishi Mohan Jha</div>
                        <div className={'sub'}>Chief Growth Officer</div>
                        <p>Rishi always had an entrepreneurial drive in his DNA, and his stints in business development reinforced it. This entrepreneurial drive has been at the core of Rishi’s corporate career and some critical decisions throughout his tenure. He began his career part-time, selling SIM cards in 1999. Since cellphones were not a “thing” in those days, selling SIM cards was quite a luxurious occupation.</p>
                        <p>His non-technical background could never hold him from growing in the technological landscape. Over the past 16 years, he has evolved as a sought-after tech-product leader. His work experience across the spectrum -- startups to MNCs -- consists of owning an end-to-end product roadmap of Kindle (Amazon) and Oyo Life.</p>
                        <p>He is innately curious to learn more, own new challenges, and network across functions. “Work Hard” and “It’s still Day1” ideologies keep him charged and brimming with energy and motivation throughout the week, week after week, month after month!</p>
                        <p>When at leisure, Rishi loves mentoring emerging product leaders, spending quality and fun-filled time with his kids (Disha & Darsh), and debating some of the hottest and trending UX cases with his wife, a senior UX leader.</p>
                        <p>- -</p>
                        <p>Rishi received a master's diploma in marketing from IP University, Delhi, and Bachelor's in commerce from Patna University, is all set to scale greater heights in the coming time.</p>
                    </div>
                    <div className={'mobile-view'}>
                        <div className={'header-cls'}>
                            <img className={'img'} src={cgo}/>
                            <div className={'desig'}>
                                <div className={'name'}>Rishi Mohan Jha</div>
                                <div className={'sub'}>Chief Growth Officer</div>
                            </div>
                        </div>
                        <p>Rishi always had an entrepreneurial drive in his DNA, and his stints in business development reinforced it. This entrepreneurial drive has been at the core of Rishi’s corporate career and some critical decisions throughout his tenure. He began his career part-time, selling SIM cards in 1999. Since cellphones were not a “thing” in those days, selling SIM cards was quite a luxurious occupation.</p>
                        <p>His non-technical background could never hold him from growing in the technological landscape. Over the past 16 years, he has evolved as a sought-after tech-product leader. His work experience across the spectrum -- startups to MNCs -- consists of owning an end-to-end product roadmap of Kindle (Amazon) and Oyo Life.</p>
                        <p>He is innately curious to learn more, own new challenges, and network across functions. “Work Hard” and “It’s still Day1” ideologies keep him charged and brimming with energy and motivation throughout the week, week after week, month after month!</p>
                        <p>When at leisure, Rishi loves mentoring emerging product leaders, spending quality and fun-filled time with his kids (Disha & Darsh), and debating some of the hottest and trending UX cases with his wife, a senior UX leader.</p>
                        <p>- -</p>
                        <p>Rishi received a master's diploma in marketing from IP University, Delhi, and Bachelor's in commerce from Patna University, is all set to scale greater heights in the coming time.</p>
                    </div>
                </div>
            </AliceCarousel>
            <div onClick={() => this.Carousel._slidePrev()} className={'prev'}></div>
            <div onClick={() => this.Carousel._slideNext()} className={'next'}></div>
        </div>

        }
}

export default class Leadership extends Component{
    state={
        preview:false,
        index:0
    }
    closePreview(){
        this.setState({
            preview:false
        })
    }
    render(){
        return <div className={'leadership-main-container'}>
            <div className={'header-with-gradient'}>
                <div className={'details-head'}>
                    <div className={'head'}>Leadership Team</div>
                </div>
            </div>
            <div className={'head-info'}>Hubler comprises of seasoned entrepreneurs who believe in
                creating & driving digital transformation. Together, we provide business expertise & support to help
                your business scale and succeed</div>
            <div className={'image-container'}></div>
            <div className={'meet-leaders'}>
                <div className={'head'}>Meet our leaders</div>
                <p>Creative, friendly, and dedicated entrepreneurs delivering Hubler for your digital workplace. Leadership who are driven by innovation & delivering world-class solutions</p>
            </div>
            <ActiveWrapper active={!this.state.preview}>
                <div className={'leaders-section'}>
                    <div className={'col'} onClick={()=>this.setState({preview:true,index:0})}>
                        <img src={picVinay}/>
                        <div className={'name'}>Vinay Agrrawal</div>
                        <div className={'designation'}>Founder</div>
                    </div>
                    <div className={'col'} onClick={()=>this.setState({preview:true,index:1})}>
                        {/*<img src={picPoovanna}/>*/}
                        <div className={'name'}>Poovanna K T</div>
                        <div className={'designation'}>CEO</div>
                    </div>
                    <div className={'col'} onClick={()=>this.setState({preview:true,index:3})}>
                        <img src={cgo}/>
                        <div className={'name'}>
                            Rishi M Jha
                        </div>
                        <div className={'designation'}>
                            Chief Growth Officer
                        </div>
                    </div>
                </div>
            </ActiveWrapper>
            <ActiveWrapper active={this.state.preview}>
                <LeaderCarousel index={this.state.index} closePreview={this.closePreview.bind(this)}/>
            </ActiveWrapper>
            <div className={'join-team'}>
                <div className={'head'}>Join our team</div>
                <Link className={'bt'} to="/career/?view=openPositions">See Open Positions</Link>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/pages/company/leadership-team.js